import { api, type RequestOptions } from "./client";

export interface ListingDto {
  id:               string;
  title:            string;
  description:      string | null;
  status:           string;
  photo_count:      number;
  view_count:       number;
  published_at:     string | null;
  created_at:       string;
  specs:            Record<string, unknown>;
  pricing:          Record<string, unknown>;
  external_refs:    Record<string, unknown>;
  provenance:       string;
  // Sprint L — `position=0` staged photo, or null if no photo yet.
  cover_photo_id:   string | null;
}

export interface DraftAcceptedDto {
  correlation_id: string;
  event_id:       string;
  message:        string;
}

export const listingsApi = {
  list(limit = 20, offset = 0, opts?: RequestOptions): Promise<ListingDto[]> {
    return api.get<ListingDto[]>(`/listings?limit=${limit}&offset=${offset}`, opts);
  },

  get(listingId: string, opts?: RequestOptions): Promise<ListingDto> {
    return api.get<ListingDto>(`/listings/${listingId}`, opts);
  },

  postDraft(
    photoUrls: string[],
    hint?: string,
    opts?: RequestOptions,
  ): Promise<DraftAcceptedDto> {
    return api.post<DraftAcceptedDto>(
      "/listings/draft",
      { photo_urls: photoUrls, hint },
      opts,
    );
  },
};
